import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { GridsterComponentInterface, GridsterItem } from 'angular-gridster2';
import _ from 'lodash';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { BrickDefinitionState } from 'src/app/store/dashboard/brick-wall/brick-definition/brick-definition.state';

@Injectable({
   providedIn: 'root',
})
export class GridsterService {
   private gridsters: Map<string, GridsterComponentInterface> = new Map();

   private itemsChanged$ = new BehaviorSubject(null);

   constructor(private store: Store) {}

   private createKey(key: string | boolean): string {
      if (typeof key === 'boolean') {
         return key ? 'pilotpanel' : 'brickwall';
      }
      return key;
   }

   public itemChanged() {
      // dispatch async to check after gridster has refreshed items
      setTimeout(() => this.itemsChanged$.next(null));
   }

   public register(key: string | boolean, gridster: GridsterComponentInterface) {
      this.gridsters.set(this.createKey(key), gridster);
   }

   public unregister(key: string | boolean) {
      this.gridsters.delete(this.createKey(key));
   }

   public get(key: string | boolean): GridsterComponentInterface {
      return this.gridsters.get(this.createKey(key));
   }

   public isAddingBrickPossible$(key: boolean | string, brickDefinitionId: string): Observable<boolean> {
      return this.itemsChanged$.pipe(
         switchMap(() => {
            {
               const gridster: GridsterComponentInterface = this.get(key);
               if (_.isNil(gridster)) {
                  return of(false);
               }

               const brickDefinition = this.store.selectSnapshot(BrickDefinitionState.brickDefinitionByIdFn)(brickDefinitionId);
               if (_.isNil(brickDefinition)) {
                  return of(false);
               }

               const newItem: GridsterItem = {
                  x: 0,
                  y: 0,
                  rows: brickDefinition.minRowHeight,
                  cols: this.createKey(true) === this.createKey(key) ? 1 : brickDefinition.minColWidth,
               };

               const canBeAdded = gridster.options.api.getNextPossiblePosition(newItem);
               return of(canBeAdded);
            }
         })
      );
   }
}
